module.exports = __webpack_public_path__ + "static/media/palm_to_palm_failed.3c4572fd.svg";